import { render, staticRenderFns } from "./AbsencesTable.vue?vue&type=template&id=44edbfab&scoped=true"
import script from "./AbsencesTable.vue?vue&type=script&lang=js"
export * from "./AbsencesTable.vue?vue&type=script&lang=js"
import style0 from "./AbsencesTable.vue?vue&type=style&index=0&id=44edbfab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44edbfab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44edbfab')) {
      api.createRecord('44edbfab', component.options)
    } else {
      api.reload('44edbfab', component.options)
    }
    module.hot.accept("./AbsencesTable.vue?vue&type=template&id=44edbfab&scoped=true", function () {
      api.rerender('44edbfab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/attendances/absences/components/AbsencesTable.vue"
export default component.exports